{
  "name": "calculators",
  "version": "1.6.3",
  "license": "MIT",
  "type": "module",
  "description": "Handy calculator tools in an easily-accessible web page",
  "homepage": "https://laskurit.pomeranssi.fi",
  "packageManager": "yarn@4.18.1",
  "scripts": {
    "start": "vite",
    "build": "vite build",
    "test": "vitest run",
    "deploy": "sh script/deploy.sh",
    "clean": "rm -rf dist/",
    "lint": "yarn lint-eslint && yarn lint-tsc",
    "lint-eslint": "eslint src",
    "lint-tsc": "tsc --noEmit",
    "fix": "eslint --fix src"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/thaapasa/calculators"
  },
  "dependencies": {
    "@dnd-kit/core": "^6.3.1",
    "@dnd-kit/sortable": "^10.0.0",
    "@dnd-kit/utilities": "^3.2.2",
    "buffer": "^6.0.3",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "cross-env": "10.1.0",
    "crypto-browserify": "^3.12.1",
    "fast-xml-parser": "^5.11.2",
    "hash-wasm": "^4.12.0",
    "lucide-react": "^1.61.0",
    "luhn-js": "1.1.2",
    "md5": "^2.3.0",
    "moment": "2.31.0",
    "ramda": "0.32.0",
    "react": "19.3.1",
    "react-autosuggest": "10.1.0",
    "react-dom": "19.3.1",
    "react-router": "^8.5.0",
    "react-sizeme": "3.0.2",
    "tailwind-merge": "^3.7.0",
    "uuid": "14.0.3",
    "xml-js": "1.6.11"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@tailwindcss/vite": "^4.3.3",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/react": "^16.3.3",
    "@types/eslint": "^9.6.1",
    "@types/jest": "30.0.0",
    "@types/jsdom": "^30",
    "@types/md5": "^2.3.6",
    "@types/node": "26.6.5",
    "@types/ramda": "0.32.0",
    "@types/react": "19.3.0",
    "@types/react-autosuggest": "10.1.11",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "^6.1.2",
    "eslint": "^10.13.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.7",
    "eslint-plugin-react-hooks": "^7.1.1",
    "eslint-plugin-simple-import-sort": "^14",
    "eslint-plugin-unused-imports": "^4.4.1",
    "jsdom": "^30.1.3",
    "prettier": "3.9.10",
    "tailwindcss": "^4.3.3",
    "tslib": "2.8.1",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.72.0",
    "vite": "^8.3.5",
    "vitest": "^5.0.5"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  }
}
